/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Config_ErrorInputs */

const vi_carrier_form_config_error = /** @type {(inputs: Carrier_Form_Config_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viettel Post không tính được cước cho tuyến này. Địa chỉ kho gửi trong cấu hình có thể chưa đúng — báo quản trị viên kiểm tra.`)
};

/**

* @param {Carrier_Form_Config_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_config_error = /** @type {((inputs?: Carrier_Form_Config_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Config_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_config_error(inputs)
});